import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { submitContactForm, getCMSPage } from '../services/api';
import { getCurrentDomain } from '../config/domains';

const Contact: React.FC = () => {
  const domain = getCurrentDomain();
  const [contactFields, setContactFields] = useState<Record<string, string | null>>({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: '',
  });

  useEffect(() => {
    getCMSPage('contact').then((res) => {
      if (res.data) setContactFields(res.data.fields);
      setLoading(false);
    });
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setSuccessMessage(null);
    setErrorMessage(null);

    const response = await submitContactForm(formData);

    if (response.error) {
      setErrorMessage(response.error);
    } else {
      setSuccessMessage(response.data?.message || 'Message sent successfully!');
      setFormData({ name: '', email: '', subject: '', message: '', phone: '' });
    }
    setSubmitting(false);
  };

  return (
    <div>
      {!loading && (contactFields.intro_text || contactFields.email || contactFields.phone || contactFields.address) && (
        <div className="page-content">
          {contactFields.intro_text && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(contactFields.intro_text) }} />}
          {contactFields.email && <p><strong>Email:</strong> {contactFields.email}</p>}
          {contactFields.phone && <p><strong>Phone:</strong> {contactFields.phone}</p>}
          {contactFields.address && <p><strong>Address:</strong> {contactFields.address}</p>}
          {contactFields.business_hours && <p><strong>Hours:</strong> {contactFields.business_hours}</p>}
        </div>
      )}

      <div style={{ marginTop: '2rem' }}>
        <h2 style={{ marginBottom: '1rem' }}>Send us a message</h2>

        {successMessage && <div className="success">{successMessage}</div>}
        {errorMessage && <div className="error">{errorMessage}</div>}

        <form className="form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name" className="form-label">Name *</label>
            <input type="text" id="name" name="name" className="form-input" value={formData.name} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">Email *</label>
            <input type="email" id="email" name="email" className="form-input" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="phone" className="form-label">Phone</label>
            <input type="tel" id="phone" name="phone" className="form-input" value={formData.phone} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label htmlFor="subject" className="form-label">Subject *</label>
            <input type="text" id="subject" name="subject" className="form-input" value={formData.subject} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label htmlFor="message" className="form-label">Message *</label>
            <textarea id="message" name="message" className="form-textarea" value={formData.message} onChange={handleChange} required />
          </div>

          <button
            type="submit"
            className="btn"
            style={{ backgroundColor: domain.primaryColor }}
            disabled={submitting}
          >
            {submitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
